import InvertingImageComponent from './InvertingImageComponent'

export default InvertingImageComponent
